import type { FeatureMiddleware } from '@cast/api-client';

import { getOverride } from '../overrides';

export const featureFlags: FeatureMiddleware<'featureFlags'> = {
  resolveFlags: async ({ next, resolve }) => {
    const flagsToForce: string[] = [];

    if (getOverride('mockLlmAnalytics')) {
      flagsToForce.push('ui__standalone--ai-optimizer-routing-tab');
    }

    // Forces the OpsPilot acknowledgement UX flag (read via useFlagsQuery in
    // the feature-control section) so it can be previewed locally.
    if (getOverride('mockOpsPilotAcknowledgement')) {
      flagsToForce.push('ui__standalone--opspilot-acknowledgement');
    }

    if (getOverride('mockCustomDashboards')) {
      flagsToForce.push(
        'ui__page-modules--organization__cost-monitoring__custom-dashboards'
      );
    }

    if (!flagsToForce.length) {
      return next();
    }

    const response = await next();
    const items = response.data?.items ?? [];

    for (const flagName of flagsToForce) {
      const existing = items.find((f) => f.flagName === flagName);
      if (existing) {
        existing.boolean = true;
      } else {
        items.push({
          flagName,
          boolean: true,
          string: '',
          integer: '',
          reason: 'STATIC',
          variant: 'enabled',
          metadata: { metadata: {} },
        });
      }
    }

    return resolve({ items }, response);
  },
};
